











import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { DictRequest, DictParam } from '@/types'
import { EPLModule } from '@/store/eplmodule'

@Component({
  name: 'DictEditForm',
  components: {
    DictForm: () =>
      import(/* webpackChunkName: "DictForm" */ '@/components/DictForm.vue')
  }
})
export default class DictEditForm extends Vue {
  @Prop(String) readonly id!: string
  @Prop(String) readonly dictName!: string

  idx = -1
  formKey = 0

  @Watch('id')
  onIDChange () {
    this.init()
    this.formKey++
  }

  @Watch('dictName')
  onDictNameChange () {
    this.init()
    this.formKey++
  }

  mounted () {
    this.init()
  }

  private init () {
    this.idx = EPLModule.DictIdx(this.dictName)
    const p = {} as DictParam
    p.idx = this.idx
    p.request = {} as DictRequest
    p.request.options = { page: 1, itemsPerPage: 1 }
    p.request.filter = [{ field: 'id', condition: this.id, operator: '=' }]
    EPLModule.fetchDictData(p).then(() => {
      // костыль для обновления списка полей справочника для AccessTable
      if (this.dictName === 'AccessTable') {
        EPLModule.dicts[this.idx].formfields[0].data.forEach((e: any) => {
          if (e.type === 'atselect') {
            EPLModule.fetchHeadersList(EPLModule.dicts[this.idx].rows[0][e.value])
          }
        })
      }
      EPLModule.showDictForm({ id: parseInt(this.id), idx: this.idx })
    })
  }
}
